// extracted by mini-css-extract-plugin
export var button = "_kf-2";
export var card = "_kf-0";
export var closeButtonContainer = "_kf-3";
export var iconContainer = "_kf-1";